import { ESTADOS_MX, PAISES } from "@/constants/direccionBanco";

const CLASE_CAMPO =
  "w-full px-4 py-3 rounded-xl bg-background border hairline text-foreground placeholder:text-muted-foreground/70 focus:outline-none focus:ring-2 focus:ring-accent/50 transition-all";

const Campo = ({ k, label, col = "", errores, children }) => (
  <label className={`flex flex-col gap-1.5 ${col}`}>
    <span className="text-xs text-muted-foreground">{label}</span>
    {children}
    {errores[k] && (
      <span data-testid={`tds-billto-error-${k}`} className="text-xs text-destructive">{errores[k]}</span>
    )}
  </label>
);

export function DireccionBancoCampos({ valores, errores, onCambio }) {
  const set = (k) => (e) => onCambio((p) => ({ ...p, [k]: e.target.value }));
  const cambiarPais = (e) => onCambio((p) => ({ ...p, country: e.target.value, administrativeArea: "" }));
  const texto = (k, ph) => (
    <input type="text" data-testid={`tds-billto-${k}`} value={valores[k]} onChange={set(k)} placeholder={ph} className={CLASE_CAMPO} />
  );
  const esMx = valores.country === "MX";
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <Campo k="address1" label="Calle y número" col="sm:col-span-2" errores={errores}>
        {texto("address1", "Av. Hidalgo 100")}
      </Campo>
      <Campo k="locality" label="Ciudad / Localidad" errores={errores}>
        {texto("locality", "Tampico")}
      </Campo>
      <Campo k="administrativeArea" label={esMx ? "Estado" : "Estado o provincia (código)"} errores={errores}>
        {esMx ? (
          <select data-testid="tds-billto-administrativeArea" value={valores.administrativeArea} onChange={set("administrativeArea")} className={CLASE_CAMPO}>
            <option value="">Selecciona tu estado</option>
            {ESTADOS_MX.map((e) => (
              <option key={e.codigo} value={e.codigo}>{e.nombre}</option>
            ))}
          </select>
        ) : (
          texto("administrativeArea", "Código")
        )}
      </Campo>
      <Campo k="postalCode" label="Código postal" errores={errores}>
        {texto("postalCode", "89000")}
      </Campo>
      <Campo k="country" label="País" errores={errores}>
        <select data-testid="tds-billto-country" value={valores.country} onChange={cambiarPais} className={CLASE_CAMPO}>
          {PAISES.map((p) => (
            <option key={p.codigo} value={p.codigo}>{p.nombre}</option>
          ))}
        </select>
      </Campo>
    </div>
  );
}
